<template>
  <div />
</template>

<script>
export default {
  name: 'PrintView',
  mounted() {
    this.$router.push({ path: '/print/products' });
  }
};
</script>
